import { Injectable } from '@angular/core';
import { BehaviorSubject, first } from 'rxjs';
import { IStringAnyMap } from '../app.types';
import { AppService } from './app.service';
import { ImpersonateService } from './impersonate.service';

@Injectable({
  providedIn: 'root'
})
export class DemoRolesService {

  public $hasRights : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public $employees : BehaviorSubject<IStringAnyMap[]> = new BehaviorSubject<IStringAnyMap[]>([]);

  public $selected : BehaviorSubject<IStringAnyMap|null> = new BehaviorSubject<IStringAnyMap|null>(null);

  public get selected() : IStringAnyMap|null {
    return this.$selected.getValue();
  }

  public get hasRights() : boolean {
    return this.$hasRights.getValue();
  }
  
  public get employees() : IStringAnyMap[] {
    return this.$employees.getValue();
  }

  constructor(
    private app : AppService,
  ) {

    this.app.$features.subscribe((_features) => {
      this.$hasRights.next(_features['DEMO_ROLES']);

      if(this.hasRights) {

        this.$employees.next([{
          email : 'elena.li.demo-user@flyingspoon.de',
          first_name : 'Elena',
          last_name : 'Li',
          name : 'Elena Li',
          level : 'Accounter',
        },{
          email : 'anastasia.morales.demo-user@flyingspoon.de',
          first_name : 'Anastasia',
          last_name : 'Morales',
          name : 'Anastasia Morales',
          level : 'Accounter-Portfolio-Leader',
        },{
          email : 'helene.zimmermann.demo-user@flyingspoon.de',
          first_name : 'Helene',
          last_name : 'Zimmermann',
          name : 'Helene Zimmermann',
          level : 'Accounter-Leader',
        },{
          email : 'chiara.garcia.demo-user@flyingspoon.de',
          first_name : 'Chiara',
          last_name : 'Garcia',
          name : 'Chiara Garcia',
          level : 'Leader',
        },{
          email : 'aisha.kallas.demo-user@flyingspoon.de',
          first_name : 'Aisha',
          last_name : 'Kallas',
          name : 'Aisha Kallas',
          level : 'Employee',
        }])
      }
      else{
        this.$employees.next([]);
      }
    });

  }
}
